

export default function TopTwoColLayout({ leftContent, rightContent }) {
  return (
   <div className="w-full grid grid-cols-1 xl:grid-cols-[2.1fr_1fr] 2.5xl:grid-cols-[2.1fr_1.01fr] gap-2 md:gap-11 2.5xl:gap-11">
  
  {/* Left Column - full width on mobile */}
  <div className="w-full lg:min-h-[470px] rounded-[15px] overflow-hidden">
    {leftContent}
  </div>

  {/* Right Column - hidden on mobile */}
  <div className="hidden xl:block lg:min-h-[470px] rounded-[15px] overflow-hidden 1xl:-translate-x-[2px]">
    {rightContent} {/* Put your Swiper here, it will now size correctly */}
  </div>

</div>

  );
}
